import React, { useState, useEffect } from 'react';
import ErpTemplate from '../../components/ErpTemplate';
import { useHistory, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import UploadButton from '../../components/UploadButton';
import { FaFileDownload, FaUpload } from 'react-icons/fa';
import moment from 'moment';
import api from '../../services/api';
import ReactSelect from '../../components/ReactSelect';
import { isNaoFarmaceutico } from '../../util/util';
import '../../css/financeiro-parcela-pagar.css';

const TIPO_IMPORTACAO_OPTIONS = [
    { value: 'novo', label: 'Registrar Novos' },
    { value: 'atualizar', label: 'Atualizar Existentes' }
];

export default function EventoImportarParticipante({ match }) {
    const id = match.params.id;
    const empresa = localStorage.getItem("empresa");
    const nomeEmpresa = localStorage.getItem("nomeEmpresa");
    const [arquivos, setArquivos] = useState([]);
    // o cliente do evento define qual planilha é esperada (layout de 6 colunas x layout completo)
    const [evento, setEvento] = useState({});
    const naoFarmaceutico = isNaoFarmaceutico(evento);
    const token = localStorage.getItem('token');
    const idUsuario = localStorage.getItem("idUsuario");
    const nomeUsuario = localStorage.getItem("nomeUsuario");
    const perfil = localStorage.getItem("perfil");
    let { state } = useLocation();
    var nomeEvento = state?.nomeEvento ?? null;

    const [dados, setDados] = useState({
        empresa: empresa,
        nomeEmpresa: nomeEmpresa,
        tipoImportacao: { value: 'novo', label: 'Registrar Novos' }
    });
    const history = useHistory();

    const buscar = (idParticipante) => {
        api({
            method: "get",
            action: '/eventoArquivo',
            token: token,
            params: {
                tipo: "participante",
                evento: id,
            }
        }).then(response => {
            var dadosRecebidos = response.data.data;
            setArquivos(dadosRecebidos);
        }).catch(err => {
            //console.log(err)
        });
    };

    const buscarEvento = () => {
        api({
            method: "get",
            action: '/evento',
            token: token,
            params: { id: id }
        }).then(response => {
            setEvento(response.data.data[0] ?? {});
        }).catch(err => {
            //console.log(err)
        });
    };

    useEffect(() => { //onload
        buscar();
        buscarEvento();
    },
        // eslint-disable-next-line
        []);

    return (
        <ErpTemplate>
            <div className="main-content container-fluid fin-pp">
                <div className="fin-pp__head">
                    <div>
                        <h1 className="fin-pp__title">Importar Participantes</h1>
                        {nomeEvento && <p className="fin-pp__subtitle">{nomeEvento}</p>}
                    </div>
                    <div className="fin-pp__actions"></div>
                </div>

                <div className="fin-pp__card" style={{ padding: 16, marginBottom: 16 }}>
                    <div className="fin-pp__filters">
                        <div className="fin-pp__field" style={{ flex: '0 0 50%' }}>
                            <label className="fin-pp__label">Tipo de Importação</label>
                            <ReactSelect
                                id="tipoImportacao"
                                value={dados.tipoImportacao}
                                onChange={(e) => {
                                    setDados({
                                        ...dados,
                                        tipoImportacao: e
                                    });
                                }}
                                options={TIPO_IMPORTACAO_OPTIONS}
                            />
                        </div>
                    </div>

                    {naoFarmaceutico ? (
                        <div className="fin-pp__filters" style={{ marginTop: 12, alignItems: 'center' }}>
                            <span className="fin-pp__minitag">Evento não farmacêutico</span>
                            <span className="fin-pp__cell-muted">
                                A planilha deve seguir o layout: Nome, Instituição, Endereço, Cargo, E-mail, Telefone.
                                Linhas com Cargo fora da lista não são importadas.
                            </span>
                            <form method="post" target="_blank" action={process.env.REACT_APP_API_URL + "/evento/exportarModeloParticipanteNaoFarmaceutico"} style={{ lineHeight: 0 }}>
                                <input type="hidden" name="data" value={JSON.stringify({ token: token, idEvento: id })} />
                                <button type="submit" className="fin-pp__btn fin-pp__btn--pill fin-pp__btn--sm">
                                    <FaFileDownload size={14} /> Baixar Modelo da Planilha
                                </button>
                            </form>
                        </div>
                    ) : null}

                    <div style={{ marginTop: 16 }}>
                        <UploadButton
                            icon={<FaUpload size={20} />}
                            color="primary"
                            acaoApi={"eventoImportarParticipante"}
                            title="Selecionar Arquivo"
                            beforeSend={() => {
                                toast.info('Aguarde, isso pode levar alguns minutos');
                            }}
                            callBack={(data) => {
                                if (data.result === "sucesso") {
                                    toast.success('Importação finalizada');
                                    // linhas rejeitadas (cargo fora do domínio, "Outros" sem especificação);
                                    // fica aberto para o operador conseguir corrigir a planilha
                                    if (data.inconsistencias && data.inconsistencias.length > 0) {
                                        toast.error(
                                            <div>
                                                Linhas não importadas:
                                                <ul style={{ margin: 0, paddingLeft: 20 }}>
                                                    {data.inconsistencias.map((item, idx) => (
                                                        <li key={idx}>Linha {item.linha} ({item.nome}): {item.motivo}</li>
                                                    ))}
                                                </ul>
                                            </div>,
                                            {
                                                autoClose: false,
                                                closeOnClick: false,
                                                draggable: false,
                                                position: "top-center"
                                            }
                                        );
                                    }
                                    if (data.participantesNaoRegistrados && data.participantesNaoRegistrados.length > 0) {
                                        toast.error(
                                            <div>
                                                Os seguintes participantes não foram encontrados para atualização:
                                                <ul style={{ margin: 0, paddingLeft: 20 }}>
                                                    {data.participantesNaoRegistrados.map((nome, idx) => (
                                                        <li key={idx}>{nome}</li>
                                                    ))}
                                                </ul>
                                            </div>,
                                            {
                                                autoClose: false,
                                                closeOnClick: false,
                                                draggable: false,
                                                position: "top-center"
                                            }
                                        );
                                    } else if (!data.inconsistencias || data.inconsistencias.length === 0) {
                                        // só sai da tela quando não há nada a corrigir na planilha
                                        history.push("/eventoParticipante/" + id);
                                    }
                                } else {
                                    toast.error(data.message || data.error || "Erro desconhecido");
                                }
                            }}
                            dados={{
                                empresa: empresa,
                                evento: id,
                                tipoImportacao: dados.tipoImportacao.value
                            }}
                        >Selecionar Arquivo</UploadButton>
                    </div>
                </div>

                <div className="fin-pp__card" style={{ overflow: 'hidden' }}>
                    <div className="fin-pp__cphead" style={{ padding: '12px 16px' }}>
                        <span className="fin-pp__cphead-title">Arquivos</span>
                    </div>
                    <div className="fin-pp__tblwrap">
                        <table className="fin-pp__tbl" style={{ tableLayout: 'auto' }}>
                            <thead>
                                <tr>
                                    <th style={{ width: 80 }}>Arquivo</th>
                                    <th style={{ width: 200 }}>Data</th>
                                    <th>Operador</th>
                                </tr>
                            </thead>
                            <tbody>
                                {arquivos.length === 0
                                    ? <tr><td colSpan={3} className="fin-pp__empty">Nenhum registro</td></tr>
                                    : arquivos.map((row, idx) => (
                                        <tr key={row.id || idx}>
                                            <td>
                                                {row.arquivo?.id ? (
                                                    <form method="get" action={process.env.REACT_APP_API_URL + "/eventoArquivo/" + row.id} target="_blank" style={{ display: 'inline' }}>
                                                        <input type="hidden" name="token" value={localStorage.getItem('token')} />
                                                        <button type="submit" className="fin-pp__btn fin-pp__btn--sm" title="Baixar arquivo">
                                                            <FaFileDownload size={16} />
                                                        </button>
                                                    </form>
                                                ) : null}
                                            </td>
                                            <td>{moment(row.created_at).format("DD/MM/YYYY HH:mm")}</td>
                                            <td>{row.operador?.nome ?? ""}</td>
                                        </tr>
                                    ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </ErpTemplate>
    );
}
